import { useDispatch, useSelector } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import { setErrorMessage, setSuccessMessage } from "../../redux/actions/appActions";

const CustomSnackbar = (): JSX.Element => {
  const dispatch = useDispatch();
  const { errorMessage, successMessage } = useSelector((state: any) => state.app);

  const handleClose = (): void => {
    if (errorMessage) {
      dispatch(setErrorMessage(""));
    } else {
      dispatch(setSuccessMessage(""));
    }
  };

  const alertStyles = {
    width: "100%",
    fontSize: "14px",
    fontWeight: 600,
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    borderRadius: "8px",
  };

  const successAlertStyles = {
    backgroundColor: "#4CAF50", // Custom green color
    color: "#ffffff", // White text for readability
    ...alertStyles,
  };

  const errorAlertStyles = {
    backgroundColor: "#f44336", // Custom red color
    color: "#ffffff", // White text for readability
    ...alertStyles,
  };

  if (successMessage) {
    return (
      <Snackbar open={!!successMessage} autoHideDuration={5000} onClose={handleClose}>
        <Alert variant="filled" onClose={handleClose} severity="success" sx={successAlertStyles}>
          {successMessage}
        </Alert>
      </Snackbar>
    );
  } else if (errorMessage) {
    return (
      <Snackbar open={!!errorMessage} autoHideDuration={5000} onClose={handleClose}>
        <Alert variant="filled" onClose={handleClose} severity="error" sx={errorAlertStyles}>
          {errorMessage}
        </Alert>
      </Snackbar>
    );
  } else return <></>;
};

export default CustomSnackbar;
